import React from 'react'

const OtpBox = React.forwardRef((props, ref) => {
  const {
    onChange = () => {},
    style = {},
    type = 'tel',
    value = '',
    ...other
  } = props
  return (
    <>
      <input
        onChange={onChange}
        ref={ref}
        type={type}
        value={value}
        style={{
          width: '43px',
          height: '48px',
          margin: '11px 10px 14px 0',

          borderRadius: '4px',
          border: 'solid 1px #e6e6e6',
          backgroundColor: '#fff',
          textAlign: 'center',
          fontSize: '20px',
          ...style
        }}
        {...other}
      />
    </>
  )
})

export default OtpBox
